import React, { useState } from 'react';
import EntityLink from '../containers/EntityLink';
import EyeIcon from './EyeIcon';
import SyncRuleDetailsDialog from './SyncRuleDetailsDialog';
import styles from '../css/components/sync_rule_entity_link.module.scss';

const SyncRuleEntityLink = ({ sourceEnv, sourceLiveId, url }) => {
  const [open, setOpen] = useState(false);

  if (!sourceLiveId) return null;

  const onCaptureClick = (e) => {
    // Intercept click before the inner EntityLink to prevent navigation
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <span onClickCapture={onCaptureClick} className={styles.container}>
        <EntityLink url={url} entityId={sourceLiveId}>
          <span className={styles.link}>
            {sourceLiveId}
            {/* eye icon inside link so it inherits link color */}
            <EyeIcon ariaLabel='View rule details' className={styles.icon} />
          </span>
        </EntityLink>
      </span>

      {open && (
        <SyncRuleDetailsDialog sourceEnv={sourceEnv} sourceLiveId={sourceLiveId} onClose={() => setOpen(false)} />
      )}
    </>
  );
};

export default SyncRuleEntityLink;
